export const HIGHLIGHT_COLORS = [
  { name: "Yellow", hex: "#facc15" },
  { name: "Green", hex: "#4ade80" },
  { name: "Pink", hex: "#f472b6" },
  { name: "Blue", hex: "#60a5fa" },
  { name: "Purple", hex: "#a78bfa" },
  { name: "Orange", hex: "#fb923c" },
];

export const DEFAULT_COVER = "/default-cover.jpg";

export const MATERIAL_TYPES = [
  { value: "book", label: "Book" },
  { value: "article", label: "Article" },
  { value: "dissertation", label: "Dissertation" },
  { value: "monograph", label: "Monograph" },
];

const U = "https://images.unsplash.com/";
export const BACKGROUNDS = [
  { name: "Grand Library", url: `${U}photo-1704391904759-11e28009335d?crop=entropy&cs=srgb&fm=jpg&q=80&w=1920` },
  { name: "Old Stacks", url: `${U}photo-1722977735215-d28f2ac6efba?crop=entropy&cs=srgb&fm=jpg&q=80&w=1920` },
  { name: "Antique Shelves", url: `${U}photo-1625053376622-e462848c453f?crop=entropy&cs=srgb&fm=jpg&q=80&w=1920` },
  { name: "Study by Fire", url: `${U}photo-1531079997448-485eb7235a2b?crop=entropy&cs=srgb&fm=jpg&q=80&w=1920` },
  { name: "Violet Haze", url: `${U}photo-1635776062127-d379bfcba9f8?crop=entropy&cs=srgb&fm=jpg&q=80&w=1920` },
  { name: "Warm Glow", url: `${U}photo-1604079628040-94301bb21b91?crop=entropy&cs=srgb&fm=jpg&q=80&w=1920` },
];

export const EMPTY_STATE_IMG =
  "https://images.pexels.com/photos/20378650/pexels-photo-20378650.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
